import { calculateExchangeRateBigInt } from "../../math/functions/calculateExchangeRate"
import { formatBigIntToViewNumber } from "./bigIntToViewNumber"

export const formatExchangeRateView = (
  priceBase?: bigint | null,
  priceQuote?: bigint | null,
  quoteSymbol = "",
  pricePrecision = 8,
  outPrecision = 8,
) => {
  const ratioBigInt = calculateExchangeRateBigInt(
    priceBase,
    priceQuote,
    pricePrecision,
    outPrecision,
  )

  if (ratioBigInt == null) {
    return {
      ratioNumber: undefined,
      ratioBigInt: undefined,
      ratioFormatted: undefined,
    }
  }

  const ratioFormatted = formatBigIntToViewNumber(
    ratioBigInt,
    outPrecision,
    quoteSymbol,
  )

  return {
    ratioNumber: Number(ratioBigInt) / 10 ** outPrecision,
    ratioBigInt,
    ratioFormatted,
  }
}
